import React, { useEffect } from 'react'
import { useTranslate, required, TextInput, NumberInput, BooleanInput, Form, FormDataConsumer } from 'react-admin'
import { useFormContext, useWatch } from 'react-hook-form'
import SaveIcon from '@mui/icons-material/Save'
import { Dialog, DialogContent, DialogTitle, Box, Button, DialogActions } from '@mui/material'
import { EditInputsWrap } from 'src/components/uiElements/CRUD/EditInputsWrap'
import LoadingButton from '@mui/lab/LoadingButton'
import { SelectInput } from 'src/components/uiElements/fields/SelectInput'
import { LIQUIDATION, PRICE } from '../helper/const'

const SyncLiquidationFields = ({ selectedRuleType, ruleLiquidationTypes }) => {
  const { control, setValue, resetField } = useFormContext()
  const show = useWatch({ control, name: 'var.show' })

  useEffect(() => {
    if (show && selectedRuleType === LIQUIDATION && ruleLiquidationTypes?.length === 1) {
      setTimeout(() => {
        setValue(
          'var.rule_liquidation_type',
          [ruleLiquidationTypes[0].short_name],
          {
            shouldDirty: true,
            shouldValidate: true,
            shouldTouch: true
          }
        )
      }, 100)
    } else {
      resetField('var.rule_liquidation_type')
    }
  }, [show, selectedRuleType, ruleLiquidationTypes, setValue, resetField])

  return null
}

export const CustomVariableModal = ({
  open,
  handleClose,
  titleModal,
  onSubmit,
  loadingButton,
  defaultValue = undefined,
  selectedRuleType,
  ruleLiquidationTypes
}) => {
  const translate = useTranslate()
  const postSave = (data, e) => {
    onSubmit && onSubmit(data, e)
  }

  return (
    <Dialog open={open} maxWidth='lg' fullWidth={true}>
      <DialogTitle>{titleModal}</DialogTitle>
      <DialogContent>
        <Form id='post_create_form' warnWhenUnsavedChanges onSubmit={postSave} defaultValues={defaultValue}>
          <SyncLiquidationFields selectedRuleType={selectedRuleType} ruleLiquidationTypes={ruleLiquidationTypes} />
          <Box>
            <EditInputsWrap label={translate('ra.field.name')}>
              <TextInput source='var.label' label='' fullWidth validate={[required()]} />
            </EditInputsWrap>
            <EditInputsWrap label={translate('ra.field.description')}>
              <TextInput source='var.description' label='' fullWidth multiline rows={5} />
            </EditInputsWrap>
            <Box sx={{ display: 'flex' }}>
              <EditInputsWrap label={translate('ra.field.value')}>
                <NumberInput source='var.value' label='' fullWidth />
              </EditInputsWrap>
              <EditInputsWrap label={translate('ra.field.show_breakdown')}>
                <BooleanInput fullWidth source='var.show' label='' />
              </EditInputsWrap>
              {selectedRuleType === PRICE && (
                <EditInputsWrap label={translate('ra.field.show_sitio')}>
                  <BooleanInput fullWidth source='var.show_sitio' label='' />
                </EditInputsWrap>
              )}
              <FormDataConsumer>
                {({ formData }) => {
                  if (formData?.var?.show && selectedRuleType === LIQUIDATION) {
                    return (
                      <EditInputsWrap label={translate('ra.field.rule_type')} className='small' style={{ flex: 1 }}>
                        <SelectInput
                          source='var.rule_liquidation_type'
                          options={ruleLiquidationTypes ?? []}
                          label=''
                          multiple
                          optionValue='short_name'
                          optionsText={['long_name']}
                          helperText={' '}
                          defaultValue={defaultValue?.var?.rule_liquidation_type}
                          disabled={ruleLiquidationTypes.length === 1}
                          validate={[required()]}
                        />
                      </EditInputsWrap>
                    )
                  }
                }}
              </FormDataConsumer>
            </Box>
          </Box>
        </Form>

        <DialogActions className='dialog-actions' style={{ marginTop: '20px' }}>
          <LoadingButton
            loading={loadingButton}
            variant='contained'
            startIcon={<SaveIcon />}
            form='post_create_form'
            type='submit'
          >
            {translate('ra.action.save')}
          </LoadingButton>
          <Button onClick={handleClose} variant='outlined' color='error'>
            {translate('ra.action.cancel')}
          </Button>
        </DialogActions>
      </DialogContent>
    </Dialog>
  )
}
